import { FONT_TITLE, FONT_COLOUR_SCORE, FONT_COLOUR_SCORE_TARGET } from 'app/constants/AppConstants';
import { createTextField } from 'utils/Text';
import * as Utils from 'utils/utils';

export default class ScoreDisplay extends Phaser.Group {
  constructor({ game, score = 0, target = 100, scoreColour = FONT_COLOUR_SCORE, targetColour = FONT_COLOUR_SCORE_TARGET }) {
    super(game);

    this.score = score;

    // add paper icon
    this.icon = this.game.make.sprite(0, 0, 'ui', 'icon_paper');
    this.icon.x = 0;
    this.icon.y = 0;
    this.add(this.icon);

    // // add main score
    this.scoreDisplay = createTextField(this.game, FONT_TITLE, 150, scoreColour);
    this.scoreDisplay.y = this.icon.height * 0.5 - 100;
    this.scoreDisplay.x = this.icon.width + 10;
    this.scoreDisplay.text = Utils.commaNumber(score);
    this.add(this.scoreDisplay);

    //  add target score in relation to main score
    this.scoreTargetDisplay = createTextField(this.game, FONT_TITLE, 55, targetColour);
    this.scoreTargetDisplay.text = '/ ' + target;
    this.scoreTargetDisplay.x = this.scoreDisplay.x + this.scoreDisplay.width + 10;
    this.scoreTargetDisplay.y = this.scoreDisplay.y + 70;
    this.add(this.scoreTargetDisplay);

    this.onUpdate = new Phaser.Signal();
    this.onAnimatedScoreComplete = new Phaser.Signal();
    this.onAnimatedScoreUpdated = new Phaser.Signal();
  }

  /*
  ============================================================================================
    GETTERS
  ============================================================================================
  */

  get width() {
    return this.scoreTargetDisplay.x + this.scoreTargetDisplay.width;
  }
  get height() {
    return this.scoreDisplay.height;
  }

  /*
  ============================================================================================
    SETTER
  ============================================================================================
  */

  setScore(value) {
    this.score = value;
    this.setScoreDisplayText(this.score);
  }

  animateScore(from, targetScore) {
    this.animatedScoreTarget = from;
    const tween = this.game.add.tween(this).to({ animatedScoreTarget: targetScore }, 1000, Phaser.Easing.Exponential.Out, true);
    tween.onUpdateCallback(this.handleAnimatedScoreUpdate, this);
    tween.onComplete.addOnce(this.handleAnimatedScoreComplete, this);
  }

  handleAnimatedScoreUpdate() {
    this.setScoreDisplayText(Math.ceil(this.animatedScoreTarget));
    this.onAnimatedScoreUpdated.dispatch();
  }

  handleAnimatedScoreComplete() {
    this.setScoreDisplayText(Math.ceil(this.animatedScoreTarget));
    this.onAnimatedScoreComplete.dispatch();
  }

  setScoreDisplayText(value) {
    this.scoreDisplay.text = Utils.commaNumber(value);
    this.scoreTargetDisplay.x = this.scoreDisplay.x + this.scoreDisplay.width + 10;
  }

  /*
  ============================================================================================
    TOODLES
  ============================================================================================
  */

  destroy() {
    // destroy stuff - it's therapudic
    this.icon.destroy(true);
    this.scoreDisplay.destroy(true);
    this.scoreTargetDisplay.destroy(true);
    // nullify it - GC flag :)
    this.icon = null;
    this.scoreDisplay = null;
    this.scoreTargetDisplay = null;
    // super!!!!!
    super.destroy(true);
  }
}
